import { render, staticRenderFns } from "./SelfieInfoStep.vue?vue&type=template&id=25fbb66b&"
import script from "./SelfieInfoStep.ts?vue&type=script&lang=ts&"
export * from "./SelfieInfoStep.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports